export default __webpack_public_path__ + "static/media/expl-gradcam_15_EN.59f03724.png";